<script>
	import request from './request.vue';
	import Category from './category.model.vue';

	import { format } from "date-fns";

	const schema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da empresa",
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			defaultSort: true,
			creationHidden: true,
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome do curso",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "description",
			displayName: "Descrição",
			kind: "text",
			validation: "",
			placeholder: "",
		},
		{
			name: "audioUrl",
			displayName: "Aúdio",
			kind: "file-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			accept: "audio/mpeg",
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("podcast", `uploadAudio/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "public",
			displayName: "Público",
			kind: "switch",
			valueOn: 1,
			valueOff: 0,
		},
	];


	export default {
		getSchema: function () {
			
			if (schema.findIndex(field => field.name === "categoryId") === -1) {
				Category.getAll()
					.then((categories) => {
						schema.push({
							name: "categoryId",
							displayName: "Categoria",
							validation: "required",
							kind: "select",
							placeholder: "",
							options: categories.map(category => ({
								name: category.name,
								value: category.id,
							})),
							search: {
								show: false,
								endWildcard: true,
								startWildcard: true,
							},
						})
					})
					.catch((err) => console.log(err));
			}

			return schema;
		},
		create: async function (entity) {
			console.log(entity);
			const response = await request.send("podcast", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("podcast", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (podcast) {
			delete podcast.audioUrl;
			let response = await request.send("podcast", "update", podcast, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("podcast", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("podcast", "search", parameters, true);
		},
	}
</script>
